fragment CraftLinkField on linkField_Link {
    ariaLabel
    customText
    text
    url
    title
    type
    target
    element {
        ... on ElementInterface {
            uri
        }
    }
}
